import React, { useEffect, useMemo, useState } from 'react';
import { api } from '../../api.js';
import PageHeader from '../../components/PageHeader.jsx';
import { Icon, SECTION_COLOR } from '../../icons.jsx';
import VendorFormModal from './VendorFormModal.jsx';
import { displayPhone } from '../../phone.js';

const TrashIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/></svg>;

export default function VendorList() {
  const [vendors, setVendors] = useState(null);
  const [query, setQuery] = useState('');
  const [formOpen, setFormOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  function load() {
    setVendors(null);
    api('/dispatch/vendors').then(setVendors).catch(() => setVendors([]));
  }

  const deleteVendor = async (e, v) => {
    e.stopPropagation();
    if (!window.confirm(`Delete "${v.name}"? This can't be undone.`)) return;
    await api(`/dispatch/vendors/${v.id}`, { method: 'DELETE' });
    load();
  };

  useEffect(() => { load(); }, []);

  const filtered = useMemo(() => {
    if (!vendors) return [];
    const q = query.trim().toLowerCase();
    if (!q) return vendors;
    return vendors.filter(v => [v.name, v.ref_number, v.category, v.contact_name, v.phone].filter(Boolean).some(val => val.toLowerCase().includes(q)));
  }, [vendors, query]);

  return (
    <div>
      <PageHeader
        icon={Icon.control}
        title="Vendors"
        subtitle="Mechanics, parts shops, tire shops, fuel suppliers — anyone who sells to you, not the other way around"
        color={SECTION_COLOR.control}
        actions={<button className="primary-btn" onClick={() => { setEditing(null); setFormOpen(true); }}>+ New vendor</button>}
      />

      <div className="panel filter-row-panel">
        <div className="filter-row">
          <input placeholder="Type to filter..." value={query} onChange={e => setQuery(e.target.value)} style={{ width: 240 }} />
        </div>
      </div>

      {vendors === null && <div className="empty">Loading...</div>}
      {vendors && vendors.length === 0 && <div className="empty">No vendors yet — click "+ New vendor" above.</div>}

      {vendors && vendors.length > 0 && (
        <table>
          <thead>
            <tr><th>Ref#</th><th>Vendor</th><th>Category</th><th>Contact</th><th>Phone</th><th>Payment Terms</th><th>Status</th><th></th></tr>
          </thead>
          <tbody>
            {filtered.map(v => (
              <tr key={v.id} onClick={() => { setEditing(v); setFormOpen(true); }} style={{ cursor: 'pointer' }}>
                <td>{v.ref_number || '—'}</td>
                <td>{v.name}</td>
                <td>{v.category || '—'}</td>
                <td>{v.contact_name || '—'}</td>
                <td>{displayPhone(v.phone) || '—'}</td>
                <td>{v.payment_terms || '—'}</td>
                <td>{v.status || 'Active'}</td>
                <td>
                  <button type="button" title="Delete vendor" onClick={e => deleteVendor(e, v)}
                    style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 30, height: 30, border: '1px solid var(--border)', background: 'var(--surface)', color: 'var(--red)', cursor: 'pointer', padding: 0 }}>
                    <TrashIcon />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {formOpen && (
        <VendorFormModal vendor={editing} onClose={() => setFormOpen(false)} onSaved={() => { setFormOpen(false); load(); }} />
      )}
    </div>
  );
}
